export default __webpack_public_path__ + "static/media/nahm_mobile.3f640a65.gif";